import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Navbar, Accordion } from 'react-bootstrap';
import { RiHomeLine } from 'react-icons/ri';
import { Button } from 'primereact/button';
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from 'helpers/authConfig';
import * as rdEnum from 'helpers/enum';


import {
    getFrontendUrl,
    getImageFileNameByID2,
    IImagesState,
    getImageLinkByID2,
    getMobileImageLinkByID2,
    getCMSAssets,
    getFrontendUrlWithSlash
} from 'helpers/Uri';

import { IAppState } from 'model/IAppState';
import { useCheckMobileScreen } from 'helpers/useCheckMobileScreen';
import { isNil } from 'lodash';

import { Menu } from 'primereact/menu';
import { Dialog } from 'primereact/dialog';
import { setTimeout } from 'timers';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
//import { InteractionStatus } from "@azure/msal-browser";
//import { loginRequest, b2cPolicies } from 'helpers/authConfig';
import { useAzureB2C } from 'helpers/useAzureB2C';
import { useClearUserDataStore } from 'helpers/useClearUserDataStore';
import { setGlobalDropdown } from 'stores/GlobalDropdown';
import { checkIsShowScrollBar } from 'stores/ScrollBarDisplay';
import { useBrandWebsiteLinks } from 'helpers/useBrandWebsiteLinks';
import { useRDNavigate } from 'helpers/useRDNavigate';

export const GlobalDrawer = (props: any) => {
    const { isClickable } = props;
    const brandWebsiteLinks = useBrandWebsiteLinks();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const azureB2C = useAzureB2C();
    const clearUserData = useClearUserDataStore();
    const rdNav = useRDNavigate();

    const [drawerVisible, setDrawerVisible] = useState(false);

    //const gaEventTracker = useAnalyticsEventTracker('Menu');

    const loginSession = useSelector((state: IAppState) => {
        return state.session;
    });

    const scrollPosition = useSelector((state: IAppState) => {
        return state.scrollPosition;
    });

    //images
    const initImage: IImagesState = {
        imageLoaded: false,
        imageList: []
    }
    const [images, setImages] = useState<IImagesState>(initImage);

    const location = useLocation();

    const isMobile = useCheckMobileScreen();

    const [activeButton, setActiveButton] = useState('lyriq');

    const toLearnMore = () => {
        let url = brandWebsiteLinks.getLearnAboutLYRIQLink();
        window.open(url, '_blank');
    }

    const toConfigure = (e: any) => {
        setDrawerVisible(false);
        navigate(rdNav(`${getFrontendUrlWithSlash()}`), { state: { closePreLoader: false, isFromOtherPage: false } });
        if (location.pathname == '/') {
            e.preventDefault();
            window.location.reload();
        }
    }

    
    const toTestDrive = () => {
        setDrawerVisible(false);
        navigate(rdNav(`${getFrontendUrl()}/${rdEnum.enumPageLink.TestDrivePage}`));
        dispatch(setGlobalDropdown(false, false));
        dispatch(checkIsShowScrollBar(true))
    }

    const toLatestNews = () => {
        let url = brandWebsiteLinks.getNewsLink();
        window.open(url, '_blank');
    }

    const toWhyCadillac = () => {
        let url = brandWebsiteLinks.getWhyCadillacLink();
        window.open(url, '_blank');
    } 

    const toBeIconic = () => {
        let url = brandWebsiteLinks.getBeIconic();
        window.open(url, '_blank');
    }
    
    const toEVLife = () => {
        let url = brandWebsiteLinks.getEVLifeLink();
        window.open(url, '_blank');
    } 

    const toUpdates = () => {
        let url = brandWebsiteLinks.getRegisterLink();
        window.open(url, '_blank');
    } 

    const toVisitUs = () => {
        let url = brandWebsiteLinks.getVisitShowRoomLink();
        window.open(url, '_blank');
    }
    
    const toFAQs = () => {
        let url = brandWebsiteLinks.getFAQLink();
        window.open(url, '_blank');
    }

    const toContactUs = () => {
        let url = brandWebsiteLinks.getContactUsLink();
        window.open(url, '_blank');
    } 

    const toService = () => {
        let url = brandWebsiteLinks.getOwnershipServiceLink();
        window.open(url, '_blank');
        setDrawerVisible(false);
    }

    const toWarranty = () => {
        let url = brandWebsiteLinks.getOwnershipWarrantLink();
        window.open(url, '_blank');
        setDrawerVisible(false);
    }
    
    const toSupport = () => {
        let url = brandWebsiteLinks.getOwnershipRoadsideAssistanceLink();
        window.open(url, '_blank');
        setDrawerVisible(false);
    }


    const onDrawerOpen = () => {
        setDrawerVisible(true);
        // dispatch(setGlobalDropdown(false, false));
    }

    const onDrawerHide = () => {
        setDrawerVisible(false);
    }

    const customHeader = (
        <div className='pop-up-dialog-header'>
            <div className='dialog-btn-panel'>
                <Button
                    // Replace 'pi-custom-close-icon' with the desired icon class
                    onClick={() => onDrawerHide()}
                    className="p-dialog-titlebar-close"
                >
                    <img alt="" src={`${getCMSAssets()}/users/cross.svg`} />
                </Button>
            </div>
        </div>
    );

    return (
        <>
            <div className='global-drawer-container'>
                <a className={"hamburger-icon"}
                    onClick={() => {
                        if (isClickable) {
                            onDrawerOpen()
                        }
                    }}

                >
                    <img className="stat-icon-link"
                        data-dtm="global nav" data-dtm2="hamburger menu"
                        src={`${getCMSAssets()}/menu/hamburger.svg`}
                        alt="hamburger menu"
                    />
                </a>
            </div>

            <Dialog header={customHeader} position='top-left' style={{ position: 'absolute', top: '0', margin: '0', width: '340px' }} draggable={false} resizable={true} closable={false}
                visible={drawerVisible} dismissableMask={true}
                onHide={() => onDrawerHide()}
                className={`drawer-dialog ${!isNil(loginSession) ? 'logged-in-height' : ''}`}
            >
                <div className='drawer-section-panel'>
                    <div className='drawer-discover-title'>
                        LYRIQ
                    </div>
                    <div className='drawer-item-card' onClick={() => toLearnMore()}>
                        <div className='left-blue-bar'></div>
                        <span>Learn More</span>
                    </div>
                    <div className='drawer-item-card' onClick={(e) => toConfigure(e)}>
                        <div className='left-blue-bar'></div>
                        <span>Build & Price</span>
                    </div>
                    <div className='drawer-item-card' onClick={() => toTestDrive()}>
                        <div className='left-blue-bar'></div>
                        <span>Test Drive</span>
                    </div>
 
                    {/* <div className='drawer-item-card' onClick={() => toCharge()}>
                        <div className='left-blue-bar'></div>
                        <span>Charge</span>
                    </div>
                    <div className='drawer-item-card' onClick={() => toOffering()}>
                        <div className='left-blue-bar'></div>
                        <span>Business offering</span>
                    </div>
                    <div className='drawer-item-card' onClick={() => toHelp()}>
                        <div className='left-blue-bar'></div>
                        <span>Help & support</span>
                    </div> */}
                </div>

                <div className='drawer-section-panel'>
                    <div className='drawer-discover-title'>
                        DISCOVER CADILLAC 
                    </div>
                    <div className='drawer-discover-card' onClick={() => toLatestNews()}>
                        <div className='left-blue-bar'></div>
                        <span>Cadillac News</span>
                    </div>
                    <div className='drawer-discover-card' onClick={() => toWhyCadillac()}>
                        <div className='left-blue-bar'></div>
                        <span>Why Cadillac</span>
                    </div>
                    <div className='drawer-discover-card' onClick={() => toBeIconic()}>
                        <div className='left-blue-bar'></div>
                        <span>Be Iconic Series</span>
                    </div>
                    <div className='drawer-discover-card' onClick={() => toEVLife()}>
                        <div className='left-blue-bar'></div>
                        <span>Your EV Life</span>
                    </div>
                    <div className='drawer-discover-card' onClick={() => toUpdates()}>
                        <div className='left-blue-bar'></div>
                        <span>Get Updates</span>
                    </div>
                    {/* <div className='drawer-discover-card' onClick={() => toRegisterInterest()}>
                        <div className='left-blue-bar'></div>
                        <span>Register Interest</span>
                    </div> */}
                    <div className='drawer-discover-card' onClick={() => toVisitUs()}>
                        <div className='left-blue-bar'></div>
                        <span>Visit Us</span>
                    </div>
                    <div className='drawer-discover-card' onClick={() => toFAQs()}>
                        <div className='left-blue-bar'></div>
                        <span>FAQs</span>
                    </div>
                    <div className='drawer-discover-card' onClick={() => toContactUs()}>
                        <div className='left-blue-bar'></div>
                        <span>Contact Us</span>
                    </div>
                </div>

                <div className='drawer-section-panel'>
                    <div className='drawer-ownership-title'>
                        OWNERSHIP
                    </div>
                    <div className='drawer-ownership-card' onClick={() => toService()}>
                        <div className='left-blue-bar'></div>
                        <span>Service</span>
                    </div>
                    <div className='drawer-ownership-card' onClick={() => toWarranty()}>
                        <div className='left-blue-bar'></div>
                        <span>Warranty</span>
                    </div>
                    <div className='drawer-ownership-card' onClick={() => toSupport()}>
                        <div className='left-blue-bar'></div>
                        <span>Roadside Assistance</span>
                    </div>
                </div>
            </Dialog>
        </>
    );
};


